import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { Eye, EyeOff, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const inputCls =
  "w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400";

export default function ClubeRedefinir() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [senha, setSenha] = useState("");
  const [senha2, setSenha2] = useState("");
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (senha.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (senha !== senha2) return toast.error("As senhas não coincidem");
    setLoading(true);
    try {
      await api.post("/indicadores/redefinir-senha", { token, senha, senha2 });
      setOk(true);
      setTimeout(() => navigate("/clube/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Link inválido ou expirado. Solicite uma nova redefinição.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6" data-testid="clube-redefinir">
      <div className="w-full max-w-sm">
        <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="h-16 w-auto object-contain rounded-xl bg-white p-1 mb-6 mx-auto border border-slate-100" />
        <h1 className="font-heading text-xl font-bold text-navy text-center">Criar nova senha</h1>
        {ok ? (
          <div className="mt-6 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 text-center" data-testid="clube-redefinir-ok">
            <CheckCircle2 className="w-8 h-8 text-emerald-500 mx-auto mb-2" />
            <p className="text-sm text-slate-600">Senha redefinida com sucesso! Redirecionando para o login...</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
            {[
              { label: "Nova senha", value: senha, set: setSenha, show: show1, toggle: () => setShow1((s) => !s), tid: "clube-redefinir-senha" },
              { label: "Confirmar nova senha", value: senha2, set: setSenha2, show: show2, toggle: () => setShow2((s) => !s), tid: "clube-redefinir-senha2" },
            ].map((f) => (
              <div key={f.tid}>
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{f.label}</label>
                <div className="relative mt-1">
                  <input
                    type={f.show ? "text" : "password"}
                    data-testid={f.tid}
                    className={`${inputCls} pr-11`}
                    value={f.value}
                    onChange={(e) => f.set(e.target.value)}
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    data-testid={`${f.tid}-eye`}
                    onClick={f.toggle}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                    aria-label={f.show ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {f.show ? <EyeOff className="w-4.5 h-4.5 w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
                  </button>
                </div>
              </div>
            ))}
            <button
              type="submit"
              data-testid="clube-redefinir-btn"
              disabled={loading || !token}
              className="w-full py-3.5 rounded-xl bg-navy text-white font-extrabold text-sm active:scale-95 transition-transform disabled:opacity-50"
            >
              {loading ? "SALVANDO..." : "SALVAR NOVA SENHA"}
            </button>
            {!token && <p className="text-xs text-red-500" data-testid="clube-redefinir-sem-token">Link inválido: token ausente.</p>}
          </form>
        )}
        <Link to="/clube/login" className="block text-center mt-4 text-xs text-navy font-semibold underline" data-testid="clube-redefinir-voltar">
          Voltar para o login
        </Link>
      </div>
    </div>
  );
}
